<template>
<div class="chapter">
<div class="inner_page">
<p class="epi2"><a id="page_5"></a>That I may reduce the monster to</p>
<p class="epi">Myself, and then may be myself</p>
<p class="epi1">In face of the monster, be more than part</p>
<p class="epi">Of it, more than the monstrous player of</p>
<p class="epi1">One of its monstrous lutes, not be</p>
<p class="epi">Alone, but reduce the monster and be,</p>
<p class="epi1">Two things, the two together as one.…</p>
<p class="epir1">—Wallace Stevens, from</p>
<p class="epir">“The Man with the Blue Guitar</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Epigraph.vue?0aee6f16